// extracted by mini-css-extract-plugin
export var icon = "_bb-3";
export var subtitle = "_bb-2";
export var title = "_bb-1";
export var value = "_bb-0";